
import html2pdf from 'html2pdf.js';
import { AssistanceService } from '../services/AssistanceService';
import Toast from '../helpers/Toast';

export const generatePDF = async (numDoc: any, typeDoc: any, serie: any) => {
    const data = {
        docType: typeDoc ?? "",
        serie: serie ?? "",
        number: numDoc ?? 0,
    };
    
    const service = new AssistanceService();

    try {
        const response = await service.GeneratePDF(data);
        const content = response.obj;

        if (typeof content === 'string' && content.trim() !== '') {
            const element = document.createElement('div');
            element.innerHTML = content;
            document.body.appendChild(element);

            // alguma documentação
            // https://rawgit.com/MrRio/jsPDF/master/docs/jsPDF.html
            // https://ekoopmans.github.io/html2pdf.js/#options

            const options = {
                margin: 3.5, // cm
                filename: `Relatório de Assistência ${typeDoc} ${serie} ${numDoc}.pdf`,
                html2canvas: { scale: 2 },
                // jsPDF: { unit: 'cm', format: 'a4', orientation: 'portrait' },
                orientation: 'p',
                unit: 'mm',
                format: 'a4',
                putOnlyUsedFonts:true,
                floatPrecision: 16 // or "smart", default is 16
            };

            // Gerar PDF
            html2pdf().from(element).set(options).save();

            document.body.removeChild(element);
        } else {
            Toast.Show("error", "Ocorreu um erro ao gerar o PDF. Por favor, tente novamente em alguns segundos.");
        }
    } catch (exp) {
        Toast.Show("error", "Ocorreu um erro ao gerar o PDF. Por favor, tente novamente em alguns segundos.");
    }
};
